/**
 * Module dependencies.
 */

import { Modal } from 'src/components/core';
import { ReactElement } from 'react';
import useTranslate from 'src/hooks/use-translate';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  isOpen?: boolean;
  onClose: () => void;
  onRemoveFavorite: () => void;
};

/**
 * `RemoveFavoriteModal` component.
 */

const RemoveFavoriteModal = (props: Props): ReactElement => {
  const { className, isOpen, onClose, onRemoveFavorite } = props;
  const { translate } = useTranslate();

  return (
    <Modal
      actions={[
        {
          label: translate('common:actions.delete'),
          onClick: onRemoveFavorite
        },
        {
          colorTheme: 'tertiary',
          label: translate('common:actions.cancel'),
          onClick: onClose
        }
      ]}
      className={className}
      isOpen={isOpen}
      onClose={onClose}
      title={translate('common:favorites.removeFavorite.modalTitle')}
    />
  );
};

/**
 * Export `RemoveFavoriteModal` component.
 */

export default RemoveFavoriteModal;
